import { toolTip } from "../../controls/toolTip";
import { ll } from "../../core/ll";
import K_Pane from "../templates/K_Pane";
import { Component, ComponentOptions } from "./component";
import { TemplateComponent } from "./templateComponent";

export interface PaneOptions extends ComponentOptions {
    components?: Component[];
    actions?: Component[];
    popUpOnlyActions?: Component[];
    entityType?: string;
    title?: string;
    header?: string;
    print?: boolean;
    gear?: boolean;
    expand?: boolean;
    minimize?: boolean;
    bindClass?: string;
    info?: boolean;
    infoTooltip?: string;
    count?: boolean;
    bsc?: string;
    width?: number | string;
    isPopUpChild?: boolean;
    ScreenEntityType?: string;
    otherInfo?: string;
    infoTooltipContent?: any;
}

export class Pane extends TemplateComponent {

    options: PaneOptions;
    content: {
        components: Component[],
        actions: Component[],
        popUpOnlyActions: Component[]
    };

    constructor(options: PaneOptions) {
        super(K_Pane, options);

        this.content = {
            components: options.components || [],
            actions: options.actions || [],
            popUpOnlyActions: options.popUpOnlyActions || []
        };
    }

    preRender() {
        const options = this.options;

        options.title = options.header;
        options.print = options.print || false;
        options.gear = options.gear || false;
        options.minimize = options.minimize || false;
        options.expand = options.expand || false;
        options.bindClass = options.bindClass || "bind-label";
        options.bindValue = options.bindValue;
        options.info = options.info || !!options.infoTooltip;
        options.count = options.count || false;
        options.screenEntityType = options.screenEntityType || "";
    }

    create() {
        $("#" + this.options.id).attr("screenentitytype", this.options.screenEntityType);

        if (this.options.infoTooltip || this.options.infoTooltipContent) {
            toolTip({
                alignX: "center",
                alignY: "top",
                alignTo: "target",
                offsetY: 5,
                selector: $(`#${this.id}_info`),
                content: this.options.infoTooltip ? ll(this.options.infoTooltip) : this.options.infoTooltipContent
            });
        }
    }

    setHeader(header) {
        var me = this;

        $("#" + me.id + " .pane-title").text(header);
    }

    setHeaderBind(headerName) {
        var me = this;

        $("#" + me.id + " .pane-title").attr("data-bind", "text: " + headerName);
    }

}
